<template>
  <div>
    <form @submit.prevent="handleSubmit" class="mt-[25px] flex flex-col items-center">
      <div
          class="w-[90%] xsm:w-full sm:w-full md:w-full lg:w-full flex flex-col gap-[30px] md:gap-[28px] lg:gap-[34px] bg-white bg-opacity-10 border backdrop-blur-md rounded-[22px] px-[15px] pb-[30px] pt-[20px] sm:px-[30px] sm:pb-[45px] sm:pt-[75px] md:px-[50px] md:py-[65px] lg:px-[50px] lg:py-[90px] text-white relative shadow-xl max-w-[980px]">

        <div v-if="isFormValid"
             class="p-[20px] absolute top-[-45px] sm:top-[-60px] md:top-[-60px] lg:top-[-90px] left-1/2 transform -translate-x-1/2 w-[70px] h-[70px] sm:w-[100px] sm:h-[100px] md:w-[100px] md:h-[100px] lg:w-[160px] lg:h-[160px] flex items-center justify-center rounded-full text-white text-2xl font-bold shadow-md border-4 border-[#FFFFFF99] animate__animated animate__fadeIn"
             style="background: linear-gradient(180deg, #E69F29 0%, #DC7E1E 100%)">
          <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="75.107"
               height="75.01" viewBox="0 0 75.107 75.01">
            <defs>
              <clipPath id="clip-path">
                <rect id="Rectangle_213" data-name="Rectangle 213" width="75.107" height="75.01" fill="#fff"/>
              </clipPath>
            </defs>
            <g id="Group_419" data-name="Group 419" transform="translate(0 0)">
              <g id="Group_418" data-name="Group 418" transform="translate(0 0)" clip-path="url(#clip-path)">
                <path id="Path_586" data-name="Path 586"
                      d="M73.861,8.536c-15.408,17.9-29.4,47.067-35.209,59.974a11.015,11.015,0,0,1-10.045,6.5h0a11.012,11.012,0,0,1-9.085-4.789L1.491,43.9a8.51,8.51,0,0,1,12.73-11.12L28.3,45.513S43.533,18.89,66.786,1.06a5.176,5.176,0,0,1,7.075,7.476"
                      transform="translate(0 0)" fill="#fff"/>
              </g>
            </g>
          </svg>
        </div>

        <div class="mt-[25px]">
          <div class="text-sm text-center mb-[10px] xsm:mb-[17px] sm:mb-[17px] md:mb-[17px] lg:mb-[22px] opacity-50">2
            of 4
          </div>
          <div class="h-[10px] sm:h-[15px] md:h-[15px] lg:h-[20px] bg-white rounded-full">
            <div class="h-[10px] sm:h-[15px] md:h-[15px] lg:h-[20px] bg-[#DC7E1E] rounded-full w-2/4"></div>
          </div>
        </div>

        <div
            class="text-[18px] xsm:text-[23px] sm:text-[23px] md:text-[23px] lg:text-[36px] tracking-[-0.72px] leading-normal md:leading-[24px] lg:leading-[44px] text-white border-2 border-[#FFFFFF98] text-center py-[20px] md:py-[35px] px-4 rounded-[34px] font-extrabold mb-0 xsm:mb-[15px] sm:mb-[15px] md:mb-[24px] lg:mb-[40px] shadow-md"
            style="background: linear-gradient(180deg, #E69F29 0%, #DC7E1E 100%)">
          <span class="w-full flex justify-center animate__animated animate__zoomIn">
            Your "wow moment" 🤩
          </span>
        </div>

        <div
            class="flex flex-col gap-[16px] xsm:gap-[20px] sm:gap-[20px] md:gap-[20px] lg:gap-[34px] text-[18px] xsm:text-[19px] sm:text-[19px] md:text-[19px] lg:text-[30px]">
          <div
              v-for="option in options"
              :key="option.value"
              @click="selected = option.value"
              class="flex items-center gap-1.5 xsm:gap-5 px-[30px] py-[6px] xsm:py-[10px] sm:py-[10px] md:py-[13px] md:px-[17px] lg:py-[21px] border-2 border-[#FFFFFF33] p-2.5 xsm:p-5 rounded-full cursor-pointer transition-colors"
              :class="selected === option.value
        ? 'bg-white text-[#2F2F2F] border border-[#E69F29AB]'
        : 'bg-[#FFFFFF40] text-white hover:bg-white/20'"
          >
            <div
                class="w-[23px] h-[23px] xsm:w-[23px] xsm:h-[23px] sm:w-[23px] sm:h-[23px] md:w-[23px] md:h-[23px] lg:w-[40px] lg:h-[40px]">
              <div
                  class="w-[23px] h-[23px] xsm:w-[23px] xsm:h-[23px] sm:w-[23px] sm:h-[23px] md:w-[23px] md:h-[23px] lg:w-[40px] lg:h-[40px] rounded-full border flex items-center justify-center"
                  :class="selected === option.value ? 'border-[#E69F29]' : 'border-white'"
              >
                <div
                    v-if="selected === option.value"
                    class="w-[13px] h-[13px] xsm:w-[13px] xsm:h-[13px] sm:w-[13px] sm:h-[13px] md:w-[13px] md:h-[13px] lg:w-[25px] lg:h-[25px] rounded-full bg-[#E69F29]"
                ></div>
              </div>
            </div>
            <span>{{ option.label }}</span>
          </div>
        </div>
      </div>

      <button
          type="submit"
          :disabled="!isFormValid"
          class="xs:text-[19px] sm:text-[26px] md:text-[26px] lg:text-[42px] bg-[#E69F29] hover:bg-white hover:text-[#DC7E1E] text-white px-[15%] py-[10px] md:px-[90px] md:py-[12px] lg:px-[166px] lg:py-[25px] rounded-full font-semibold tracking-[-0.84px] mt-[30px] lg:mt-[80px]"
      >
        CONTINUE
      </button>
    </form>
  </div>
</template>

<script>
import {ref} from "vue";

export default {
  name: "Step4Page",
  props: {
    userInfo: Object,
    answers: Object
  },
  data() {
    return {
      selected: ref(''),
      options: [
        {label: 'Not just seen - remembered 🎯', value: 'remembered'},
        {label: 'Right user - right place 📰', value: 'engage-context'},
        {label: 'Eyes on - minds in 👀', value: 'real-attention'},
      ]
    }
  },
  computed: {
    isFormValid() {
      return this.selected;
    },
  },
  methods: {
    async handleSubmit() {
      let dataForCollectionData = {
        email: this.userInfo.email,
        wowMoment: this.selected,
      }

      console.log('dataForCollectionData ', dataForCollectionData)
      await fetch('https://form-to-kv-worker.ocm.workers.dev/', {
        method: 'POST',
        body: JSON.stringify(dataForCollectionData),
        headers: {'content-type': 'application/json'}
      })
          .then(response => {
            console.log(response.status)
            if (this.selected && (response.status !== 409 && response.status !== 404 && response.status !== 500)) {
              this.$emit("update-answers", {...this.answers, wowMoment: this.selected});
            }
          })
          .catch(error => console.error('Error upload user:', error));
    },
  }
};
</script>

<style scoped>
button:disabled {
  cursor: not-allowed;
  opacity: 0.6;
  background-color: #e49e29;
  color: white;
}
</style>